import {
  observable,
  computed,
  action,
  useStrict,
  runInAction,
  autorun,
  isObservable,
  isObservableArray,
  isObservableMap
} from "mobx";
import BaseStore from "./BaseStore";
import foStorage from "../utils/foStorage";

useStrict(true);

class StoreDebugSettings extends BaseStore {
  constructor() {
    super();

    // 从storage读取
    const debugSettings = foStorage.getItem(foStorage.KEYS.debugSettings);
    if (debugSettings) {
      this.update(debugSettings);
    }

    // 同步改动到storage, 只保存一个小时
    const expires = new Date().getTime() + 3600 * 1000;
    autorun(() => {
      foStorage.setItem(
        foStorage.KEYS.debugSettings,
        {
          jssdkDebug: this.jssdkDebug,
          vconsole: this.vconsole,
          weinre: this.weinre
        },
        expires
      );
    });
  }

  @observable
  jssdkDebug = false;
  @observable
  vconsole = false;
  @observable
  weinre = false;

  @action.bound
  clearDebugSettings() {
    foStorage.removeItem(foStorage.KEYS.debugSettings);
  }
}

export default new StoreDebugSettings();



// WEBPACK FOOTER //
// ./src/store/storeDebugSettings.js